/**
 * state of the shop
 */
const state = {
    name: '',
    interval: '',
    amount: 0,
    isStudio: null
}

const mutations = {
    setName: function (state, name) {
        state.name = name
    },

    setInterval: function (state, interval) {
        state.interval = interval
    },

    setAmount: function (state, amount) {
        state.amount = amount
    },

    setIsStudio: function (state, isStudio) {
        state.isStudio = isStudio
    }
}

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/transaction.js